export const nav = {
  allAds: "Alla annonser",
  createAd: "Skapa annons",
  pricing: "Priser",
  tips: "Tips",
  about: "Om Sellavo",
  help: "Hjälp och support",
  inboxUnread: "Inkorg – {{count}} olästa. Öppna inkorgen för att läsa dem.",
  inboxUnreadTitle: "{{count}} oläst{{suffix}} – öppna inkorgen så markeras de som lästa",
  adminPending: "{{count}} adminärenden väntar{{support}}",
  adminPendingSupport: " – varav {{count}} support",
  sellavoHome: "Sellavo – till startsidan",
} as const;

export const footer = {
  colSellavo: "Sellavo",
  colTrade: "Sälja och köpa",
  colLegal: "Juridik",
  om: "Om Sellavo",
  howItWorks: "Så fungerar det",
  whyItCosts: "Varför kostar det?",
  pricing: "Priser",
  tips: "Tips",
  guides: "Guider",
  buyAndSellLocally: "Köpa och sälja på din ort",
  compare: "Jämför säljsajter",
  rules: "Annonsregler",
  videoScan: "Videoskanning",
  help: "Hjälp och support",
  terms: "Användarvillkor",
  privacy: "Integritetspolicy",
  cookies: "Cookiepolicy",
  cookieSettings: "Cookieinställningar",
  tagline: "Fota, låt AI skriva annonsen och sälj snabbt och snyggt.",
} as const;

export const errors = {
  notFoundTitle: "Sidan finns inte",
  notFoundBody: "Adressen du försökte nå finns inte, eller så har sidan flyttat.",
  offlineTitle: "Ingen uppkoppling",
  offlineBody:
    "Vi når inte Sellavo just nu. Kolla nätet och försök igen — sidor du besökt tidigare fungerar fortfarande.",
  busyTitle: "Många besökare just nu",
  busyBody: "Det är fler än vanligt inne på Sellavo. Vänta några sekunder och försök igen.",
  errorTitle: "Sidan kunde inte laddas",
  errorBody: "Något gick fel hos oss. Prova att ladda om sidan eller gå tillbaka till startsidan.",
} as const;
